module.exports = __webpack_public_path__ + "media/app/assets/specializations/druid/feral-78f30928ab8f37d6a66f9252bc2c6cfd.png";